import React, { useState, useEffect } from "react";
import {
  Table,
  Button,
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import DatePicker from "react-datepicker";
import Placeholder from "../../../assets/images/Placeholder.gif";
import "react-datepicker/dist/react-datepicker.css";
import caldropdown from "../../../assets/images/cal-dropdown.svg";
import { get } from "../../../api/axios";
import endpoints from "../../../api/endpoints";
import check from "../../../assets/images/check.svg";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import SimpleBar from "simplebar-react";
import Cash from "../../../assets/images/bars.svg";
import Up from "../../../assets/images/trade-up.svg";
import Down from "../../../assets/images/trade-down.svg";
const GymPayout = () => {
  document.title = " Gyms Revenue | Elevated - Admin Dashboard";
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const gymId = searchParams.get("gymId");
  const [timeFilter, setTimeFilter] = useState("week");
  const [dropdownOpen, setDropdownOpen] = useState({ dateRange: false });
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [startSearchDate, setStartSearchDate] = useState();
  const [endSearchDate, setEndSearchDate] = useState();
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(false);
  const [totalAmount, setTotalAmount] = useState(0);
  const [seletedGymId, setSeletedGymId] = useState("");
  const [selectedGym, setSelectedGym] = useState("");
  const [gymData, setGymData] = useState([]);
  const { currentUser } = useSelector((state) => state.auth);
  const [stats, setStats] = useState([]);
  const gymIds = async () => {
    try {
      let endpoint;
      if (currentUser.appRole === "admin") {
        endpoint = `${endpoints.gym}/admin?limit=50`;
      } else if (currentUser.appRole === "gymOwner") {
        endpoint = `${endpoints.gym}/admin?userId=${currentUser.id}&limit=50`;
      } else {
        console.error("User role is not admin or gymOwner.");
        return;
      }

      const resp = await get(endpoint);

      if (resp?.data?.success) {
        const gymList = resp.data.data || [];
        setGymData(gymList);

        if (gymList.length > 0) {
          setSelectedGym(gymList[0]?.name || "Unknown Gym");
          setSeletedGymId(gymList[0]?._id || null);
        } else {
        }
      } else {
        console.error(
          "Failed to fetch gyms:",
          resp?.data?.message || "Unknown error"
        );
      }
    } catch (error) {
      console.error("Error in fetching gyms:", error);
    }
  };
  useEffect(() => {
    if (
      currentUser.appRole == "gymOwner" ||
      currentUser.appRole == "gymStaff" ||
      currentUser.appRole == "admin"
    ) {
      gymIds();
    }
  }, []);
  const toggleDropdown = (key) => {
    setDropdownOpen((prevState) => ({ ...prevState, [key]: !prevState[key] }));
  };

  const formatDate = (date) => {
    const d = new Date(date);
    return d.toISOString().split("T")[0];
  };

  const handleClearDates = () => {
    setStartDate(null);
    setEndDate(null);
    setStartSearchDate(null);
    setEndSearchDate(null);
  };

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await get(
        `${endpoints.pass}/authorize/list?gymId=${seletedGymId}`
      );
      if (response && response?.data) {
        setData(response?.data?.data || []);
        setTotalAmount(response?.data?.totalAmount || 0);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [seletedGymId]);
  const fetchFinance = async () => {
    try {
      setLoading(true);
      const response = await get(`${endpoints.finance}/${seletedGymId}`);
      if (response && response.data) {
        setStats(response.data.data[0] || []);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (seletedGymId) {
      fetchFinance();
    }
  }, [seletedGymId]);
  const formatNumber = (num) => {
    if (num >= 1000000000) {
      return (num / 1000000000).toFixed(2) + "B";
    } else if (num >= 1000000) {
      return (num / 1000000).toFixed(2) + "M";
    } else if (num >= 1000) {
      return (num / 1000).toFixed(2) + "K";
    }
    return isNaN(num) || num === null ? "0.00" : Number(num).toFixed(2);
  };
  return (
    <div className="">
      <Container fluid>
        <Row className="gx-2">
          <Col xl={3} lg={6} md={6} sm={6} xs={12}>
            <Card className="p-3 d-flex flex-column justify-content-between rounded-4 pb-0 mb-2 d-block">
              <div className="d-flex justify-content-between align-items-center">
                <div
                  className="ff-sora font-size-16 fw-normal"
                  style={{
                    height: "50px",
                  }}
                >
                  <h5 className="ff-sora font-size-20 fw-medium m-0">
                    Current
                    <br /> Month
                  </h5>
                  <p
                    className="ff-sora  fw-medium"
                    style={{ fontSize: "30px" }}
                  >
                    $
                    {formatNumber(
                      parseFloat(
                        stats.currentMonthAmount -
                          stats.currentMonthAmount * 0.2
                      )
                    )}
                  </p>
                </div>
                <div
                  className="rounded-5 d-flex justify-content-center bg-brand-orange align-items-center "
                  style={{
                    width: "50px",
                    height: "50px",
                  }}
                >
                  <img src={Cash} alt="cash" />
                </div>
              </div>
              <div className=" ff-sora font-size-16 light-black d-flex justify-content-between align-items-center fw-normal pt-5">
                <p>
                  Passes Redeemed:
                  {stats.currentMonthCount ? stats.currentMonthCount : "0"}
                </p>
                <div className="d-flex justify-content-center align-items-center">
                  <img src={Up} alt="cash" />
                </div>
              </div>
            </Card>
          </Col>
          <Col xl={3} lg={6} md={6} sm={6} xs={12}>
            <Card className="p-3 d-flex flex-column justify-content-between rounded-4 pb-0 mb-2">
              <div className="d-flex justify-content-between align-items-center">
                <div
                  className="ff-sora font-size-16 fw-normal"
                  style={{
                    height: "50px",
                  }}
                >
                  <h5 className="ff-sora font-size-20 fw-medium mb-0">
                    Current <br /> Week
                  </h5>
                  <p
                    className="ff-sora  fw-medium"
                    style={{ fontSize: "30px" }}
                  >
                    $
                    {formatNumber(
                      parseFloat(
                        stats.currentWeekAmount - stats.currentWeekAmount * 0.2
                      )
                    )}
                  </p>
                </div>
                <div
                  className="rounded-5 d-flex justify-content-center bg-brand-orange align-items-center "
                  style={{
                    width: "50px",
                    height: "50px",
                  }}
                >
                  <img src={Cash} alt="cash" />
                </div>
              </div>
              <div className=" ff-sora font-size-16 light-black d-flex justify-content-between align-items-center fw-normal pt-5">
                <p>
                  Passes Redeemed:
                  {stats.currentWeekCount ? stats.currentWeekCount : "0"}
                </p>
                <div className="d-flex justify-content-center align-items-center">
                  <img src={Down} alt="cash" />
                </div>
              </div>
            </Card>
          </Col>
          <Col xl={3} lg={6} md={6} sm={6} xs={12}>
            <Card className="p-3 d-flex flex-column justify-content-between rounded-4 pb-0 mb-2">
              <div className="d-flex justify-content-between align-items-center">
                <div
                  className=""
                  style={{
                    height: "50px",
                  }}
                >
                  <h5 className="ff-sora font-size-20 fw-medium mb-0">
                    Last <br /> Month
                  </h5>
                  <p
                    className="ff-sora  fw-medium"
                    style={{ fontSize: "30px" }}
                  >
                    $
                    {formatNumber(
                      parseFloat(
                        stats.lastMonthAmount - stats.lastMonthAmount * 0.2
                      )
                    )}
                  </p>
                </div>
                <div
                  className="rounded-5 d-flex justify-content-center bg-brand-orange align-items-center "
                  style={{
                    width: "50px",
                    height: "50px",
                  }}
                >
                  <img src={Cash} alt="cash" />
                </div>
              </div>
              <div className=" ff-sora font-size-16 light-black d-flex justify-content-between align-items-center fw-normal pt-5">
                <p>
                  Passes Redeemed:{" "}
                  {stats.lastMonthCount ? stats.lastMonthCount : "0"}
                </p>
                <div className="d-flex justify-content-center align-items-center">
                  <img src={Up} alt="cash" />
                </div>
              </div>
            </Card>
          </Col>
          <Col xl={3} lg={6} md={6} sm={6} xs={12}>
            <Card className="p-3 d-flex flex-column justify-content-between rounded-4 pb-0 mb-2 m-0">
              <div className="d-flex justify-content-between align-items-center">
                <div
                  className="ff-sora font-size-16 fw-normal"
                  style={{
                    height: "50px",
                  }}
                >
                  <h5 className="ff-sora font-size-20 fw-medium mb-0">
                    Current <br /> Year
                  </h5>
                  <p
                    className="ff-sora  fw-medium"
                    style={{ fontSize: "30px" }}
                  >
                    $
                    {formatNumber(
                      parseFloat(
                        stats.totalYearAmount - stats.totalYearAmount * 0.2
                      )
                    )}
                  </p>
                </div>
                <div
                  className="rounded-5 d-flex justify-content-center bg-brand-orange align-items-center "
                  style={{
                    width: "50px",
                    height: "50px",
                  }}
                >
                  <img src={Cash} alt="cash" />
                </div>
              </div>
              <div className=" ff-sora font-size-16 light-black d-flex justify-content-between align-items-center fw-normal pt-5">
                <p>
                  Passes Redeemed:{" "}
                  {stats.totalYearCount ? stats.totalYearCount : "0"}
                </p>
                <div className="d-flex justify-content-center align-items-center">
                  <img src={Down} alt="cash" />
                </div>
              </div>
            </Card>
          </Col>
        </Row>
        <Card className="rounded-4">
          <CardBody>
            <div className="col-12 d-flex flex-column flex-md-row justify-content-between align-items-center mb-3">
              {/* Title Section */}
              <div className="d-flex  flex-row justify-content-start align-items-center gap-2 w-100 mt-2 mt-sm-0">
                <span className="font-size-20 fw-bold primary-black ff-sora mb-2 mb-sm-0 ">
                  Gyms Revenue
                </span>
              </div>

              {/* Dropdown Section */}
              <div className="d-flex flex-column flex-sm-row justify-content-end align-items-center gap-2 w-100 mt-2 mt-md-0">
                <div className="d-flex flex-xs-row gap-2 w-100 w-sm-auto">
                  {/* Gym Dropdown */}
                  <Dropdown
                    isOpen={dropdownOpen.selectGym}
                    toggle={() => toggleDropdown("selectGym")}
                    className="w-100 w-sm-auto"
                  >
                    <DropdownToggle
                      caret
                      className="filter-btn d-flex justify-content-between align-items-center  w-100 w-xs-auto"
                    >
                      <span className=" w-100 w-xs-auto">
                        {selectedGym}
                        <small style={{ fontSize: "9px" }}>
                          (Selected GYM)
                        </small>
                      </span>
                      <img src={check} alt="Location" className="ms-2" />
                    </DropdownToggle>
                    <DropdownMenu
                      style={{ zIndex: 1, maxHeight: "200px", width: "200px" }}
                    >
                      <SimpleBar style={{ maxHeight: "185px", width: "100%" }}>
                        {gymData.map((item, index) => (
                          <DropdownItem
                            key={index}
                            className="fw-normal ff-sora secondary-black font-size-14"
                            onClick={() => {
                              setSelectedGym(item.name);
                              setSeletedGymId(item._id);
                            }}
                          >
                            {item.name}
                          </DropdownItem>
                        ))}
                      </SimpleBar>
                    </DropdownMenu>
                  </Dropdown>

                  {/* <Dropdown
        className="w-100 w-sm-auto"
        isOpen={dropdownOpen.dateRange}
        toggle={() => toggleDropdown("dateRange")}
      >
        <DropdownToggle
          caret
          className="filter-btn d-flex ff-sora justify-content-between align-items-center w-100"
        >
          <span className="fw-normal ff-sora secondary-black font-size-14">
            Date Range
          </span>
          <img src={caldropdown} alt="Calendar Dropdown" className="ms-2" />
        </DropdownToggle>

        <DropdownMenu style={{ zIndex: 2 }} className="p-3">
          <div className="d-flex flex-column">
            <span className="mb-2 fw-normal ff-sora secondary-black font-size-14">
              Start Date
            </span>
            <DatePicker
              selected={startDate}
              onChange={(date) => {
                setStartDate(date);
                let temp = formatDate(date);
                setStartSearchDate(temp);
              }}
              dateFormat="yyyy/MM/dd"
              className="form-control fw-normal ff-sora secondary-black font-size-14 mb-3"
              placeholderText="Select Start Date"
            />
            <span className="mb-2 fw-normal ff-sora secondary-black font-size-14">
              End Date
            </span>
            <DatePicker
              selected={endDate}
              onChange={(date) => {
                setEndDate(date);
                let temp = formatDate(date);
                setEndSearchDate(temp);
              }}
              dateFormat="yyyy/MM/dd"
              className="form-control fw-normal ff-sora secondary-black font-size-14"
              placeholderText="Select End Date"
            />
          </div>
          <button
            type="button"
            onClick={handleClearDates}
            className="btn btn-link text-danger fw-normal ff-sora font-size-12 mt-2 p-0"
          >
            Clear
          </button>
        </DropdownMenu>
      </Dropdown> */}
                </div>
              </div>
            </div>

            <div className="table-responsive">
              <div
                className="hide-scrollbar table-responsive rounded-4"
                style={{
                  height: data?.length > 0 ? "500px" : "auto",
                }}
              >
                <Table
                  hover
                  className="table-borderless table-centered table-nowrap"
                >
                  <thead className="table-bordered">
                    <tr className="ff-sora font-size-14 fw-bold primary-black">
                      <th>No</th>
                      <th>User Name</th>
                      <th>Gym Name</th>
                      <th className="primary-black fw-bold ff-sora font-size-14">
                        Pass Type
                      </th>
                      <th className="primary-black fw-bold ff-sora font-size-14">
                        Pass Price
                      </th>
                      <th className="primary-black fw-bold ff-sora font-size-14">
                        PlatForm Fee (10%)
                      </th>
                      <th className="primary-black fw-bold ff-sora font-size-14">
                        Platform Discount (10%)
                      </th>

                      <th>Redeem Date</th>
                      <th>Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                      <tr>
                        <td colSpan={8} className="text-center">
                          <div className="d-flex justify-content-center align-items-center">
                            <div
                              className="spinner-border"
                              style={{
                                width: "3rem",
                                height: "3rem",
                                color: "#3BABA6",
                              }}
                              role="status"
                            >
                              <span className="visually-hidden">
                                Loading...
                              </span>
                            </div>
                          </div>
                        </td>
                      </tr>
                    ) : data.length === 0 ? (
                      <></>
                    ) : (
                      data?.map((item, index) => {
                        const totalAmount = item.passDetail?.price
                          ? parseFloat(item.passDetail.price) +
                            (item.passDetail.tax || 0)
                          : 0;

                        return (
                          <tr
                            key={item._id + index}
                            className="ff-sora fw-normal font-size-14 secondary-black"
                          >
                            <td>{index + 1}</td>
                            <td className="text-capitalize">
                              {item.userDetail.firstName}{" "}
                              {item.userDetail.lastName}
                            </td>
                            <td className="text-capitalize">
                              {item.gymDetail.name}
                            </td>
                            <td className="text-capitalize">
                              {item.passDetail.name}
                            </td>
                            <td>
                              <span>
                                $
                                {formatNumber(
                                  parseFloat(item.passDetail.price)
                                ) || "0"}
                              </span>
                            </td>

                            <td>
                              <span>
                                $
                                {formatNumber(
                                  parseFloat(item.passDetail.price * 0.1)
                                ) || "0"}
                              </span>
                            </td>

                            <td>
                              <span>
                                $
                                {formatNumber(
                                  parseFloat(item.passDetail.price * 0.1)
                                ) || "0"}
                              </span>
                            </td>

                            <td>
                              {item.createdAt
                                ? new Date(item.createdAt).toLocaleDateString()
                                : "N/A"}
                            </td>
                            <td>
                              $
                              {formatNumber(
                                parseFloat(totalAmount - totalAmount * 0.2)
                              )}
                            </td>
                          </tr>
                        );
                      })
                    )}
                  </tbody>
                </Table>
                {!loading && data.length === 0 && (
                  <div className="d-flex flex-column align-items-center justify-content-center vh-50">
                    <img
                      src={Placeholder}
                      alt="No record placeholder"
                      className="object-fit-contain img-fluid h-25 w-25 rounded-3 mb-3"
                    />
                    <p className="mt-3 ff-sora font-size-16 fw-normal">
                      No Record Found!
                    </p>
                  </div>
                )}
              </div>
            </div>

            <div className="d-flex justify-content-between align-items-center table-bordered mt-3 p-2">
              <span className="fw-bold ff-sora secondary-black">
                Grand Total
              </span>
              <span className="fw-bold ff-sora secondary-black">
                ${formatNumber(parseFloat(totalAmount - totalAmount * 0.2))}
              </span>
            </div>
          </CardBody>
        </Card>
      </Container>{" "}
      <div
        className="d-flex justify-content-between align-items-center"
        style={{
          height: "60px",
          position: "sticky",
          bottom: "0",
          zIndex: "10",
        }}
      ></div>
    </div>
  );
};

export default GymPayout;
